// extracted by mini-css-extract-plugin
export default {"loginPage":"LoginPage_loginPage__aF1Sx","content":"LoginPage_content__CrAXl","button":"LoginPage_button__gZk2H"};